import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentListComponent } from './attachment-list.component';
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import {CommonFeModule} from "../../../../../pastureProFECommon/projects/common-lib/src/lib/common-fe.module";

@NgModule({
  declarations: [
    AttachmentListComponent,
  ],
  exports: [
    AttachmentListComponent
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    CommonFeModule,
  ]
})
export class AttachmentListModule {
}
